export const ORG_ROLES = ['owner', 'admin', 'marketing', 'sales', 'read_only'];
export const ORG_ROLE_LABELS = {
    owner: 'Eigenaar',
    admin: 'Beheerder',
    marketing: 'Marketing',
    sales: 'Sales',
    read_only: 'Alleen lezen',
};
//# sourceMappingURL=orgRoles.js.map